export const STATE_RESPONSIBILITY_GROUP_EXCEL_TYPES = {
    PREPARATION: 'Preparation',
    CHARGED: 'Charged',
    ALL: 'All',
};
